import React, {Component} from 'react';
import {Helmet} from "react-helmet";

class FAQs_Schema_org extends Component {
    
    constructor(props, context) {
        super(props, context);
        
        this.createListQuestions = this.createListQuestions.bind(this);
        this.createJSONSchema = this.createJSONSchema.bind(this);
        
    }
    
    
    createListQuestions() {
        
        
        /* let array = [
                 {
                     "@type": "Question",
                     "name": "¿Qué nota tiene WELKHOMEclub?",
                     "acceptedAnswer":
                         {
                             "@type": "Answer",
                             "text": "WELKHOMEclub tiene una nota de 9.2/10. Los usuarios de TheFork han dado una nota según las categorías siguientes:<br /><ul><li>Calidad de la comida: 9.1/10</li><li>Servicio: 9.5/10</li><li>Ambiente: 9.1/10</li>"
                         }
                 }
             ]*/
        
        
        return this.props.listQuestions.map((q) => {
            return {
                "@type": "Question",
                "name": q.question,
                "acceptedAnswer":
                    {
                        "@type": "Answer",
                        "text": q.answer
                    }
            }
        })
    }
    
    createJSONSchema() {
        return {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": this.createListQuestions()
        }
    }
    
    render() {
        return (
            <Helmet>
                <script id="srp_faq" type="application/ld+json">
                    {JSON.stringify(this.createJSONSchema())}
                </script>
            </Helmet>
        );
    }
    
    componentWillMount() {
    
    }
    
    componentDidMount() {
    
    
    }
    
    componentDidUpdate() {
    
    }
    
    
}

export default FAQs_Schema_org
